/**
 * DOCUMENT_TARGET is an object that defines target attributes for hyperlinks or forms.
 * These attributes specify where the linked document or form submission will be displayed.
 *
 * Properties:
 * - Self: '_self' - Opens the document in the same window or tab.
 * - Blank: '_blank' - Opens the document in a new window or tab.
 */
export const DOCUMENT_TARGET = {
  Self: '_self',
  Blank: '_blank',
};
